// Menu boczne i nagłówek strony. Klucze sekcji to `SectionKey` z `@/config/navigation`,
// więc `t(`sections.${section.key}.label`)` jest sprawdzane przez TypeScript.
export default {
  groups: {
    main: 'MENU GŁÓWNE',
    config: 'KONFIGURACJA',
  },
  sections: {
    dashboard: {
      label: 'Pulpit',
      title: 'Pulpit',
      subtitle: 'Podsumowanie pracy asystenta głosowego',
    },
    conversations: {
      label: 'Rozmowy',
      title: 'Rozmowy',
      subtitle: 'Wszystkie połączenia z transkrypcjami i nagraniami',
    },
    // VERIFY: brak w mockupie, sekcja kampanii outbound.
    'outbound-calls': {
      // Short: the full title is cut off in the sidebar.
      label: 'Wychodzące',
      title: 'Połączenia wychodzące',
      subtitle: 'Kampanie, scenariusze, historia rozmów i sprzedawcy',
    },
    statistics: {
      label: 'Statystyki',
      title: 'Statystyki',
      subtitle: 'Sprawy, tematy i efekt dla urzędu',
    },
    satisfaction: {
      label: 'Satysfakcja',
      title: 'Satysfakcja mieszkańców',
      subtitle: 'Oceny wystawiane po zakończeniu rozmowy',
    },
    documents: {
      label: 'Baza wiedzy',
      title: 'Aktualizacja bazy wiedzy',
      subtitle: 'Materiały źródłowe, z których korzysta asystent',
    },
    company: {
      label: 'Ustawienia',
      title: 'Ustawienia',
      subtitle: 'Konfiguracja asystenta głosowego',
    },
  },
  // VERIFY: brak w mockupie, mockup nie ma przycisku wylogowania.
  logout: 'Wyloguj',
} as const;
